import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useNavigate, useParams } from 'react-router-dom'
import PaymentDetailsTable from './payment_details_table'

function PaymentDetailsPage() {
  const { paymentId } = useParams()
  const navigate = useNavigate()

  if (typeof paymentId !== 'string') {
    navigate(AppRoutePaths.payments.index)
    return
  }

  return <PaymentDetailsTable paymentId={paymentId} />
}

export default PaymentDetailsPage
